import React from "react";
import { Link } from "react-router-dom";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { HiArrowUpRight, HiArrowUp } from "react-icons/hi2";

export default function Footer() {
  return (
    <footer className="portfolio-footer">
      <div className="home-shell">
        <div className="portfolio-footer-top">
          <Link to="/" className="portfolio-footer-brand">
            sep<span>.</span>aminian
          </Link>
          <div className="portfolio-footer-links">
            <a
              href="https://github.com/sephml"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillGithub /> GitHub <HiArrowUpRight />
            </a>
            <a
              href="https://www.linkedin.com/in/amirsepehr-aminian/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn /> LinkedIn <HiArrowUpRight />
            </a>
          </div>
        </div>
        <div className="portfolio-footer-bottom">
          <span>© {new Date().getFullYear()} Sep Aminian</span>
          <span>
            London, UK <span aria-hidden="true">↗</span>
          </span>
          <button
            type="button"
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
                  .matches
                  ? "instant"
                  : "smooth",
              })
            }
          >
            Back to top <HiArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
